module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('userLevel') == '1'
  ) ? _c('div', {
    staticStyle: {
      "margin-top": "-25px",
      "background": "#f8f8ff"
    }
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "lang": _vm.langFF,
      "format": "YYYY-MM-DD",
      "confirm": ""
    },
    on: {
      "change": _vm.onConfirmDateRangeFF
    },
    model: {
      value: (_vm.searchModal.dateRangeFF),
      callback: function($$v) {
        _vm.$set(_vm.searchModal, "dateRangeFF", $$v)
      },
      expression: "searchModal.dateRangeFF"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning btn-icon text-white mr-2",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "daterange-btn",
      "data-toggle": "tooltip",
      "title": "",
      "data-placement": "bottom",
      "data-original-title": "Calendar"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadExcel('2')
      }
    }
  }, [_vm._m(1)])], 1)]), _vm._v(" "), _c('md-card-content', {
    staticStyle: {
      "background": "beige"
    }
  }, [_c('b-table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.filteredFF,
      "fields": _vm.fieldsFF,
      "per-page": _vm.perPageFF,
      "sort-by": _vm.sortByFF,
      "sort-desc": _vm.sortDescFF,
      "sort-direction": _vm.sortDirectionFF,
      "striped": ""
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortByFF = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDescFF = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "top-row",
      fn: function(ref) {
        var fields = ref.fields;

        return _vm._l((fields), function(fieldF) {
          return _c('td', {
            key: fieldF.key,
            staticStyle: {
              "background": "#43377b"
            }
          }, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.filtersFF[fieldF.key]),
              expression: "filtersFF[fieldF.key]"
            }],
            staticStyle: {
              "width": "130px",
              "height": "25px",
              "border-radius": "5px",
              "font-size": "12px",
              "text-align": "center"
            },
            attrs: {
              "placeholder": fieldF.label
            },
            domProps: {
              "value": (_vm.filtersFF[fieldF.key])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.filtersFF, fieldF.key, $event.target.value)
              }, function($event) {
                _vm.getAdvanceSearchDataFF('0', '1')
              }]
            }
          })])
        })
      }
    }, {
      key: "consignee",
      fn: function(row2) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(row2.value)
          }
        })]
      }
    }, {
      key: "clientName",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.clientName))]), _vm._v(" "), _c('br'), _vm._v("\n          Assignment No :\n          " + _vm._s(row1.item.ffExportFclSeries) + "\n          "), _c('br'), _vm._v("\n          Assignment Date :\n          " + _vm._s(_vm._f("moment")(row1.item.loginTime)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-pagination', {
    attrs: {
      "per-page": _vm.perPageFF,
      "total-rows": _vm.totalRowsFF
    },
    on: {
      "change": function($event) {
        _vm.onPageChangeFF($event)
      }
    },
    model: {
      value: (_vm.currentPageFF),
      callback: function($$v) {
        _vm.currentPageFF = $$v
      },
      expression: "currentPageFF"
    }
  })], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('span', {
    staticClass: "subpage-title"
  }, [_vm._v("Freight Forwarding Export Reports")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-995ff6f4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboardFfReports.vue
// module id = 2807
// module chunks = 0